import { Component, inject, Input, ViewChild } from "@angular/core";
import { RiskModel } from "@app/risk/models/RiskModel";
import { RiskDataService } from "@app/risk/services/RiskDataService";
import { TranslocoService } from "@jsverse/transloco";

import { RiskPeriodScoreChartComponent } from "./risk-period-score-chart/risk-period-score-chart.component";
import { RiskScoreChartModel } from "@app/risk/models/RiskScoreChartModel";

@Component({
    selector: "risk-result-overview",
    templateUrl: "./risk-result-overview.component.html",
    styleUrls: ["./risk-result-overview.component.scss"],
    standalone: false
})
export class RiskResultOverviewComponent {
    private _riskDS = inject(RiskDataService);

    @ViewChild("likelihoodScoreChart", { static: true })
    likelihoodScoreChart: RiskPeriodScoreChartComponent;
    @ViewChild("impactScoreChart", { static: true })
    impactScoreChart: RiskPeriodScoreChartComponent;

    loadedCharts = false;
    numberOfKris: number;

    @Input() risk: RiskModel;

    private _translocoService = inject(TranslocoService);

    load(refresh: boolean) {
        if (!refresh && this.loadedCharts) {
            return;
        }

        this.loadedCharts = false;
        this._riskDS.getPeriodScoreData(this.risk.guid).subscribe((chartModel) => {
            this.loadLikelihoodChart(chartModel);
            this.loadImpactChart(chartModel);

            this.loadedCharts = true;
        });
        this.numberOfKris = this.risk.kriGuids.length;
    }

    private loadLikelihoodChart(chartModel: RiskScoreChartModel) {
        chartModel = JSON.parse(JSON.stringify(chartModel)) as RiskScoreChartModel;

        // Only show likelihood serie
        chartModel.series = chartModel.series.filter(
            (x) =>
                x.index === chartModel.likelihoodIndex ||
                x.index === chartModel.grossLikelihoodIndex
        );
        chartModel.chartTitle = this._translocoService.translate('risk.resultOverview.likelihoodOverTime');

        this.likelihoodScoreChart.loadChart(chartModel);
    }

    private loadImpactChart(chartModel: RiskScoreChartModel) {
        chartModel = JSON.parse(JSON.stringify(chartModel)) as RiskScoreChartModel;

        // Only show all impact series (including custom impacts)
        chartModel.series = chartModel.series.filter(
            (x) =>
                x.index === chartModel.impactIndex ||
                x.index === chartModel.grossImpactIndex ||
                x.index >= chartModel.customImpactStartIndex
        );
        chartModel.chartTitle = this._translocoService.translate('risk.resultOverview.impactOverTime');

        this.impactScoreChart.loadChart(chartModel);
    }
}
